var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 235,
    height: 251,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C7.08768326 0.07925524 13.21406135 2.74507149 19.375 6.0625 C21.125 8.3125 21.125 8.3125 21 12.25 C20.73509693 13.60965553 20.44143014 14.96390489 20.125 16.3125 C19.78939446 17.97871061 19.45554487 19.64527807 19.125 21.3125 C28.92852334 20.97268983 38.33127483 19.52758851 47.95141602 17.68457031 C62.67314894 14.93849538 62.67314894 14.93849538 68.4375 18.125 C69.07300781 18.46144531 69.70851562 18.79789063 70.36328125 19.14453125 C72.23904156 20.38810627 73.68018485 21.58481441 75.125 23.3125 C75.5625 26.3125 75.5625 26.3125 75.125 29.3125 C72.9534727 31.4592224 71.60314717 32.2490231 68.55957031 32.65307617 C67.14562988 32.6295105 67.14562988 32.6295105 65.703125 32.60546875 C64.16591797 32.5909668 64.16591797 32.5909668 62.59765625 32.57617188 C61.53417969 32.55103516 60.47070312 32.52589844 59.375 32.5 C58.29605469 32.48646484 57.21710938 32.47292969 56.10546875 32.45898438 C53.4448058 32.42366584 50.78515704 32.37434199 48.125 32.3125 C48.47884766 33.52292969 48.47884766 33.52292969 48.83984375 34.7578125 C49.22830373 39.60025885 47.64862142 42.82945241 45.6875 47.1875 C45.34912109 47.97125 45.01074219 48.755 44.66210938 49.5625 C43.82979879 51.48502022 42.97919934 53.39960472 42.125 55.3125 C47.42296068 55.19270461 52.72079076 55.068388 58.01855469 54.94018555 C59.81442509 54.89732736 61.61032355 54.85562691 63.40625 54.81518555 C66.01310882 54.75626937 68.61984243 54.69365993 71.2265625 54.62890625 C72.07898529 54.60834167 72.93140808 54.5877771 73.80966187 54.56658936 C78.88408026 54.42724578 83.8980731 54.10450812 88.953125 53.64453125 C94.07343062 53.24513085 97.53001757 53.42154842 102.25 55.4375 C103.28382813 55.85257813 104.31765625 56.26765625 105.3828125 56.6953125 C108.49234225 58.52913774 110.16543444 60.29345641 112.125 63.3125 C112.125 66.4375 112.125 66.4375 111.125 69.3125 C108.99825684 71.35889953 107.79643657 72.27039296 104.8203125 72.45703125 C103.97210938 72.34746094 103.12390625 72.23789063 102.25 72.125 C101.30406982 72.00543945 100.35813965 71.88587891 99.38354492 71.76269531 C97.38489769 71.48656543 95.39026411 71.17516187 93.40698242 70.80444336 C81.98026253 68.78939082 70.51093718 69.01120078 58.94360352 69.05175781 C55.35870999 69.06236329 51.77433028 69.05187884 48.18945312 69.0390625 C32.74231487 69.02862448 17.49480529 69.78846304 2.125 71.3125 C1.19015778 71.4040033 0.25531555 71.49550659 -0.70785522 71.58978271 C-6.0499688 72.12054793 -11.38453763 72.70105069 -16.71655273 73.32495117 C-18.45895195 73.52634388 -20.20215176 73.72091777 -21.94604492 73.90893555 C-32.18485425 75.01288861 -41.9577973 76.54437211 -51.81846619 79.58308411 C-59.57954402 81.96521531 -65.77878234 83.09673975 -73.40234375 79.6796875 C-78.59267643 76.8098353 -82.98624874 73.74487187 -85.0625 68.0625 C-84.875 65.3125 -84.875 65.3125 -83.9375 63.375 C-80.62998129 61.67112673 -77.4118379 62.50150532 -73.875 63.3125 C-73.215 63.6425 -72.555 63.9725 -71.875 64.3125 C-60.57558162 65.14830335 -49.39672071 63.74268392 -38.19360352 62.37988281 C-37.07526123 62.24420898 -35.95691895 62.10853516 -34.8046875 61.96875 C-33.80679199 61.84306641 -32.80889648 61.71738281 -31.78076172 61.58789062 C-28.79437625 61.30485897 -25.87289956 61.26573611 -22.875 61.3125 C-23.02646484 60.7777002 -23.17792969 60.24290039 -23.33398438 59.69189453 C-24.01700905 57.27451257 -24.69605016 54.85602943 -25.375 52.4375 C-25.61347656 51.59574219 -25.85195312 50.75398438 -26.09765625 49.88671875 C-26.32324219 49.08105469 -26.54882812 48.27539062 -26.78125 47.4453125 C-26.99072266 46.70168457 -27.20019531 45.95805664 -27.41601562 45.19189453 C-27.875 43.3125 -27.875 43.3125 -27.875 41.3125 C-28.45507812 41.46847656 -29.03515625 41.62445313 -29.6328125 41.78515625 C-35.38519657 43.21850607 -39.60817912 44.04781662 -45.06640625 41.1484375 C-50.33215728 37.90397146 -53.83118467 34.71281752 -56.875 29.3125 C-57.3125 26.5 -57.3125 26.5 -56.875 24.3125 C-56.215 23.6525 -55.555 22.9925 -54.875 22.3125 C-50.00338043 22.58825205 -46.92429669 23.68592917 -42.875 26.3125 C-39.79243211 27.31714923 -37.0937616 27.38931156 -33.8671875 27.26171875 C-32.39862305 27.20455688 -32.39862305 27.20455688 -30.90039062 27.14624023 C-29.34094727 27.07385132 -29.34094727 27.07385132 -27.75 27 C-26.15575195 26.93051147 -26.15575195 26.93051147 -24.52929688 26.85961914 C-15.25654421 26.4139207 -6.07809526 25.50936719 3.125 24.3125 C2.97289063 23.03761719 2.82078125 21.76273438 2.6640625 20.44921875 C2.57850098 19.73209717 2.49293945 19.01497559 2.40478516 18.27612305 C1.92148468 14.88416342 1.14421379 13.12645545 -1.5625 10.96484375 C-3.30729542 9.70197771 -5.07128883 8.48925274 -6.875 7.3125 C-4.66119232 0.37590261 -4.66119232 0.37590261 0 0 Z M19.25 34.125 C18.2914209 34.21120605 17.3328418 34.29741211 16.34521484 34.38623047 C5.89400417 35.3672535 -4.4895601 36.79764045 -14.875 38.3125 C-14.58882813 38.96605469 -14.30265625 39.61960937 -14.0078125 40.29296875 C-12.61251183 44.01216674 -11.68066647 47.76790453 -10.75 51.625 C-10.56824219 52.36556641 -10.38648437 53.10613281 -10.19921875 53.86914062 C-9.7545787 55.682804 -9.31434255 57.49754608 -8.875 59.3125 C-1.39179684 59.40025611 6.03198593 59.09750033 13.5 58.625 C14.67433594 58.57150391 15.84867188 58.51800781 17.05859375 58.46289062 C18.18136719 58.38876953 19.30414063 58.31464844 20.4609375 58.23828125 C21.98533447 58.15187378 21.98533447 58.15187378 23.54052734 58.0637207 C26.31897192 57.53216142 26.31897192 57.53216142 27.90600586 54.99731445 C28.91261002 52.78028542 29.72051946 50.78568836 30.29296875 48.4296875 C30.54916992 47.39134766 30.54916992 47.39134766 30.81054688 46.33203125 C30.97619141 45.62433594 31.14183594 44.91664062 31.3125 44.1875 C31.48974609 43.47207031 31.66699219 42.75664063 31.84960938 42.01953125 C32.56877029 39.04848037 33.125 36.38002383 33.125 33.3125 C28.45933616 33.3125 23.89400287 33.70691891 19.25 34.125 Z ",
    fill: "#010101",
    transform: "translate(103.875,22.6875)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.86882812 0.639375 1.73765625 1.27875 2.6328125 1.9375 C3.51710938 2.55625 4.40140625 3.175 5.3125 3.8125 C7.85265816 6.01992179 9.85427912 8.16188272 11.7578125 10.9375 C11.7578125 15.2050026 10.56771207 18.43384507 8.85546875 22.25390625 C6.17546399 28.86317307 5.25143788 35.668 4.1953125 42.6875 C3.80728306 45.24618919 3.41045258 47.80356255 3.00390625 50.359375 C2.83560303 51.47924805 2.6672998 52.59912109 2.49389648 53.75292969 C1.34372741 58.72898453 0.06106469 62.0686652 -4.2421875 64.9375 C-9.63409074 64.60050605 -9.63409074 64.60050605 -11.65625 62.39575195 C-13.13713507 60.75636407 -13.13713507 60.75636407 -15.265625 60.65698242 C-16.42964844 60.72429565 -16.42964844 60.72429565 -17.6171875 60.79296875 C-18.50631836 60.83736084 -19.39544922 60.88175293 -20.31152344 60.92749023 C-21.76220215 61.02525757 -21.76220215 61.02525757 -23.2421875 61.125 C-24.25313477 61.18179932 -25.26408203 61.23859863 -26.30566406 61.29711914 C-29.61939017 61.49089986 -32.93051762 61.71140206 -36.2421875 61.9375 C-37.37076172 62.01162109 -38.49933594 62.08574219 -39.66210938 62.16210938 C-46.47439149 62.61471415 -53.2805735 63.12139552 -60.08496094 63.68017578 C-62.12416523 63.84637755 -64.16386686 64.00663355 -66.20410156 64.15966797 C-68.8436731 64.35927231 -71.48017498 64.58182642 -74.1171875 64.8125 C-74.87741211 64.86656006 -75.63763672 64.92062012 -76.42089844 64.97631836 C-81.24234863 65.43753425 -83.67136778 66.7418751 -87.2421875 69.9375 C-89.8671875 69.9375 -89.8671875 69.9375 -92.2421875 68.9375 C-95.55365934 65.56573667 -95.75056995 62.54519486 -96.0859375 57.93359375 C-96.14116577 57.25506851 -96.19639404 56.57654327 -96.2532959 55.87745667 C-96.42880374 53.7107329 -96.58722393 51.54328314 -96.7421875 49.375 C-97.74587764 31.4845836 -97.74587764 31.4845836 -105.44921875 15.69140625 C-106.2421875 13.9375 -106.2421875 13.9375 -105.50390625 11.77734375 C-104.2421875 9.9375 -104.2421875 9.9375 -102.2421875 8.9375 C-99.3259467 8.92659887 -96.42268705 8.96402556 -93.5078125 9.0234375 C-82.20467318 9.13438809 -71.19597073 7.93532329 -59.9921875 6.5625 C-56.03320451 6.09332035 -52.07332616 5.6319958 -48.11328125 5.171875 C-47.16043747 5.06024017 -46.20759369 4.94860535 -45.22587585 4.83358765 C-36.95569062 3.87599817 -28.6814747 3.13464431 -20.36816406 2.65869141 C-15.92863396 2.36080086 -12.21079275 1.66177108 -7.99609375 0.1953125 C-4.49066297 -0.93132317 -3.62282809 -1.18724005 0 0 Z M-83.2421875 20.9375 C-84.08894817 24.66951925 -84.20148387 27.20690301 -83.2421875 30.9375 C-75.67432447 31.10711059 -68.32523926 30.43300546 -60.8046875 29.625 C-58.15771882 29.34978052 -55.51066078 29.07588276 -52.86328125 28.8046875 C-51.83176941 28.69870995 -51.83176941 28.69870995 -50.77941895 28.59059143 C-42.31606254 27.72909323 -33.84201091 26.98848967 -25.3671875 26.25 C-24.60632843 26.18356293 -23.84546936 26.11712585 -23.06155396 26.04867554 C-18.78863967 25.67586083 -14.51551873 25.30550979 -10.2421875 24.9375 C-8.72398057 21.38107039 -8.0200996 18.82403827 -8.2421875 14.9375 C-30.13295161 9.09996291 -61.13407818 17.78511743 -83.2421875 20.9375 Z M-22.3984375 36.48828125 C-23.60959229 36.57606339 -23.60959229 36.57606339 -24.84521484 36.6656189 C-27.47772761 36.85794501 -30.10998211 37.05351386 -32.7421875 37.25 C-33.63413818 37.31619537 -34.52608887 37.38239075 -35.44506836 37.45059204 C-51.08623794 38.6190418 -66.66214795 40.11896889 -82.2421875 41.9375 C-82.2421875 45.8975 -82.2421875 49.8575 -82.2421875 53.9375 C-68.26031821 53.38956188 -54.33891752 52.24491591 -40.40136719 51.04174805 C-31.02009099 50.23444499 -21.64006431 49.52465144 -12.2421875 48.9375 C-10.4927257 42.53534929 -10.4927257 42.53534929 -10.2421875 35.9375 C-14.31732565 35.9375 -18.3378376 36.19069124 -22.3984375 36.48828125 Z ",
    fill: "#010101",
    transform: "translate(161.2421875,97.0625)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.12109375 1.71484375 2.12109375 1.71484375 4.4375 3.9375 C24.60599237 22.48662437 46.07655915 32.89288658 73.97167969 31.77636719 C78.31745686 31.5591484 82.65941296 31.30369705 87 31 C86.37720331 29.41579871 85.75166599 27.83267469 85.125 26.25 C84.77695313 25.36828125 84.42890625 24.4865625 84.0703125 23.578125 C83.05978696 21.03811093 83.05978696 21.03811093 81.875 18.84375 C80.75386003 16.48134792 80.85660856 14.58104594 81 12 C85.85434325 13.60870677 89.62806691 16.37871049 93.75 19.3125 C99.34585803 23.23417178 104.95228126 26.8088633 111 30 C114.49185706 31.84251181 116.64676081 33.12619779 118.1875 36.9375 C118 40 118 40 116 42.75 C109.92613627 47.3053978 103.57328482 47.30839539 96.25390625 47.30078125 C95.32513168 47.30506638 94.39635712 47.3093515 93.43943787 47.31376648 C91.47696747 47.31949024 89.51447587 47.3200245 87.55200195 47.31567383 C84.60264105 47.31254262 81.65431319 47.3358973 78.70507812 47.36132812 C53.81775311 47.44579153 30.31362012 42.55453153 11 26 C10.28714844 25.40960938 9.57429688 24.81921875 8.83984375 24.2109375 C4.06920125 20.18484614 -0.0035989 15.78556385 -4 11 C-4.804375 10.113125 -5.60875 9.22625 -6.4375 8.3125 C-8.2494581 5.63080201 -8.36254329 4.1722538 -8 1 C-4.88225741 -0.89291514 -3.42493641 -1.2898298 0 0 Z ",
    fill: "#010101",
    transform: "translate(74,178)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.475 0.495 2.475 0.495 5 1 C5.86076658 17.06764288 1.37943234 34.47583802 -9 47 C-12.40117025 49.9669783 -14.21922782 50.89413259 -18.6875 51.5 C-22 51 -22 51 -23.9375 49.5625 C-25.51341286 45.76176899 -25.69665434 42.05015709 -25 38 C-23.09627532 34.22802376 -20.64055342 31.36981612 -17.75 28.3125 C-9.85138053 19.63297974 -4.61627907 10.78822727 0 0 Z ",
    fill: "#010101",
    transform: "translate(48,168)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C14.11461645 2.19019911 28.55460794 10.30130815 37.125 21.875 C40.33720315 27.22867191 40.8272753 32.41514036 39.4375 38.4375 C38 40 38 40 34.6875 41 C30.13317779 41 29.26005112 40.06323689 26 37 C24.58256049 35.06564396 23.23239695 33.08094245 21.9375 31.0625 C17.39455221 24.20700991 12.03297717 18.37636695 6.36425781 12.4453125 C3.47657561 9.38606436 0.73888143 6.19214702 -2 3 C-1.34 2.01 -0.68 1.02 0 0 Z ",
    fill: "#010101",
    transform: "translate(169,162)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.09262074 -0.29350004 4.60283924 -0.25832717 7.24609375 1.4609375 C8.33083984 2.40839844 8.33083984 2.40839844 9.4375 3.375 C13.99152744 7.33431545 18.00056147 9.20907079 24.0859375 8.9765625 C25.51657167 8.87156183 26.94634554 8.7541731 28.375 8.625 C29.11105469 8.56828125 29.84710938 8.5115625 30.60546875 8.453125 C32.40452468 8.31293882 34.20241939 8.15798214 36 8 C35.52046875 9.29357422 35.52046875 9.29357422 35.03125 10.61328125 C33.73442887 14.87215973 33.56629051 18.86997605 33.34375 23.29296875 C33 26 33 26 31 29 C27.9169824 30.23320704 25.8486932 30.28674015 22.69921875 29.22265625 C12.78832005 24.64483834 6.16884023 18.27140661 0.99609375 8.7109375 C-0.12973645 5.64691336 -0.1852309 3.23916599 0 0 Z ",
    fill: "#010101",
    transform: "translate(101,164)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#FFFFFF",
    transform: "translate(0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.28b8e858d10c0c298d7fde3520214f69.svg";
export { ForwardRef as ReactComponent };